import { TraitRegistryCategory } from '../../TraitRegistryCategory';
import { TraitTypeSelect } from '../../traitTypes/TraitTypeSelect';
import { TraitTypeText } from '../../traitTypes/TraitTypeText';
export class TraitRegistrySystemInner extends TraitRegistryCategory {
    label = 'Inner';
    constructor(parent) {
        super(parent);
        super.init();
    }
    actorName = () => new TraitTypeSelect({
    /*  label: 'Akteurname',
      init: 'app',
      select: ({ at }) => Object.keys(at.context).map(actorType => [actorType]) as any */
    });
    aspectName = () => new TraitTypeSelect({
    /* label: 'Aspektname',
     init: 'inner',
     select: ({ at }) => at.context.actor.actorAspects.allAspectsArray.map(aspect => [aspect.name]) as any */
    });
    preloadBundle = () => new TraitTypeSelect({
        default: 'preload_if_active',
        /* label: 'Preload',
         select: [['force_preload'], ['disable_preload'], ['preload_if_active']] */
    });
    /* Temporary trait only attached until package is available */
    waitForPackage = () => new TraitTypeText();
}
